<template> 
    <div> 
        <b-row class="mt-2 mb-2">  

            <b-col md="4">
                <b-form-group >
                    <b-form-textarea v-model.trim="searchVal" style="height:100px" placeholder="Type to Search : 1023,Test"></b-form-textarea>  
                </b-form-group>
            </b-col>
      
            <b-col md="3">
                <b-form-group>
                    <b-input-group>
                        <b-form-select  v-model="deliveryMode" :options="options"></b-form-select>
                    </b-input-group>
                </b-form-group>
            </b-col>
      
            <b-col md="2">
                <b-button :disabled="searchVal.length == 0 && deliveryMode.length==0" @click="searchInLoadManagement()"  size="md" variant="primary">Search</b-button>
                &nbsp;
                <b-button :disabled="searchVal.length == 0 && deliveryMode.length==0" @click="clearSearch()"    size="md" variant="danger">Clear</b-button>
            </b-col>        
         
            <!-- <b-col md="2">
                <a :href="loadurl" target="_blank" v-if="totalRows>0">
                    <b-button variant="primary" @click="downlaodloadurl">Download</b-button>
                </a>
            </b-col> -->

        </b-row> 
        <b-row>
            <b-col sm="12" class="text-right">
                <p>
                    <b>Total Records :<span style="color:red;">{{totalRows}}</span></b> 
                </p>
            </b-col> 
            <b-col sm="12">
                <b-table 
                    show-empty 
                    responsive  
                    :items="items"  
                    :fields="fields"  
                    :current-page="currentPage"  
                    :per-page="perPage"     
                    outlined="true" 
                    :busy="isBusy"
                >
                    <div slot="table-busy" class="text-center text-danger my-2">
                        <b-spinner class="align-middle"></b-spinner>
                        <strong>Loading...</strong>
                    </div>  

                    <template slot="select" slot-scope="row">
                        <b-form-group>
                            <input class="parentAWBcheckbox" type="checkbox"  v-bind:value="row.item.parentawb" @change="multiselectdesign($event,row.item)"  v-model='checkedParentAWB' />
                        </b-form-group>
                    </template>
                
                    <template slot="parentawb" slot-scope="row">
                        <button v-b-tooltip.hover title="View Details" @click="viewDetails(row.item)" style="background-color:white !important;" class="btn btn-link"  >
                            <span style="color:#1b8eb7">{{row.item.parentawb}}</span>
                        </button>
                    </template>

                    <template slot="invoicevalue" slot-scope="row">
                        <span>&#8377; {{row.item.invoicevalue}}</span>
                    </template>
                    <template slot="awbphysicalweight" slot-scope="row">
                        <span> {{row.item.awbphysicalweight}} {{row.item.unit}}</span>
                    </template>
                        <template slot="valweight" slot-scope="row">
                        <span> {{row.item.valweight}} {{row.item.unit}}</span>
                    </template>
                    <template slot="mpscount" slot-scope="row">
                        <button v-b-tooltip.hover title="View Count Details" @click="viewProduct(row.item)" style="background-color:white !important;" class="btn btn-link"  v-if="row.item.mpscount !=''" >
                            <span style="color:#1b8eb7"> {{row.item.mpscount}}</span>
                        </button>
                    </template>
                </b-table>
            </b-col> 
            <b-col sm="12">
                <paginate 
                    :page-count="noofpages"
                    :page-range="60"
                    :margin-pages="2"
                    :click-handler="clickCallback"
                    :prev-text="'Prev'"
                    :next-text="'Next'"
                    :container-class="'pagination'"
                    :page-class="'page-item'">
                </paginate>
            </b-col>
        </b-row>
        <b-modal size="xl" title="AWB Details" v-model="awbdetailsmodal" @ok="awbdetailsmodal = false" hide-footer>
            <template slot="default" slot-scope="{ hide }">
                <b-row class="col-md-12" > 
                    <div class="col-md-3">
                    <span><b>Vehicle Id :</b></span>&nbsp;
                    <span>{{detailsitem.vehicle_id}}</span>
                    </div>
                    <div class="col-md-3">
                    <span><b>Parent Awb :</b></span>&nbsp;
                    <span>{{detailsitem.parentawb}}</span>
                    
                    </div>
                    <div class="col-md-3">
                    <span><b>Category :</b></span>&nbsp;
                    <span>{{detailsitem.category}}</span>
                    
                    </div>
                    
                    <div class="col-md-3">
                    <span><b>Delivery Status :</b></span>&nbsp;
                    <span>{{detailsitem.deliverystatus}} </span>
                    
                    </div>
                </b-row>
                <br>
                <b-row class="col-md-12" > 
                    <div class="col-md-3">
                        <span><b>Load ID :</b></span>&nbsp;
                        <span>{{detailsitem.invoiceno}}</span>
                    </div>

                    <div class="col-md-3">
                        <span><b>Invoice Date :</b></span>&nbsp;
                        <span>{{detailsitem.invoicedate}} </span>
                    </div>
                    
                    <div class="col-md-3">
                        <span><b>Invoice Value :</b></span>&nbsp;
                        <span>{{detailsitem.invoicevalue}}</span>
                    </div>
                    
                    <div class="col-md-3">
                        <span><b>Pick Up Date:</b></span>&nbsp;
                        <span>{{detailsitem.pickupdatetime}}</span>
                    </div>
                </b-row>
                <br>
                <b-row class="col-md-12" >
                    <div class="col-md-3">
                        <span><b>Seller Name :</b></span>&nbsp;
                        <span>{{detailsitem.sellername}}</span>
                    </div> 
                    <div class="col-md-3">
                        <span><b>Registor No :</b></span>&nbsp;
                        <span>{{detailsitem.sellergstregnumber}} </span>
                    </div>
                    <div class="col-md-3">
                        <span><b> Weight :</b></span>&nbsp;
                        <span>{{detailsitem.valweight}} {{detailsitem.unit}}</span>    
                    </div>
                    <div class="col-md-3">
                        <span><b>Risk :</b></span>&nbsp;
                        <span>{{detailsitem.risksurcharge}}</span>
                    </div>
                </b-row>
                <br>
                <b-row class="col-md-12" >
                    <div class="col-md-3">
                        <span><b>Seller Address :</b></span>&nbsp;
                        <span>{{detailsitem.selleraddress}}</span>
                    </div>
                    <div class="col-md-3">
                        <span><b>Seller State :</b></span>&nbsp;
                        <span>{{detailsitem.supplysellerstateplace}}</span>
                    </div> 
                    <div class="col-md-3">
                        <span><b>Seller Pincode :</b></span>&nbsp;
                        <span>{{detailsitem.sellerpincode}}</span>
                    </div>
                    <div class="col-md-3">
                        <span><b>Route Mode :</b></span>&nbsp;
                        <span>{{detailsitem.routemode}}</span>
                    </div>
                </b-row>
                <br>
                <b-row class="col-md-12" >
                    <div class="col-md-3">
                        <span><b>Source Company :</b></span>&nbsp;
                        <span>{{detailsitem.sourcecompanyname}}</span>
                    </div> 
                    <div class="col-md-3">
                        <span><b> Source Mailid :</b></span>&nbsp;
                        <span>{{detailsitem.sourceemailid}} </span>
                    </div>
                    <div class="col-md-3">
                        <span><b>Source Mobile No :</b></span>&nbsp;
                        <span>{{detailsitem.sourcemobileno}}</span>
                    </div>
                    <div class="col-md-3">
                        <span><b>Source Type :</b></span>&nbsp;
                        <span>{{detailsitem.sourcetype}}</span>
                    </div>
                     
                </b-row>
                <br>
                <b-row class="col-md-12" >
               
                    <div class="col-md-3">
                        <span><b> Source Address :</b></span>&nbsp;
                        <span>{{detailsitem.sourceaddress}} </span>
                    </div>
                      
                    <div class="col-md-3">
                        <span><b>Source City :</b></span>&nbsp;
                        <span>{{detailsitem.sourcecity}}</span>
                        
                    </div>
                    <div class="col-md-3">
                        <span><b>Source State :</b></span>&nbsp;
                        <span>{{detailsitem.sourcestate}}</span>
                    </div> 
                      
                    <div class="col-md-3">
                        <span><b>Source Pincode :</b></span>&nbsp;
                        <span>{{detailsitem.sourcepincode}}</span>
                        
                    </div>
                     
                </b-row>
                <br>
                <b-row class="col-md-12" >
                    <div class="col-md-3">
                        <span><b>Destination Company :</b></span>&nbsp;
                        <span>{{detailsitem.destinationcompanyname}}</span>
                    </div> 
                    <div class="col-md-3">
                        <span><b>Mail Id :</b></span>&nbsp;
                        <span>{{detailsitem.destinationemailid}} </span>
                        
                    </div>
                      
                    <div class="col-md-3">
                        <span><b>Destination Mobile No :</b></span>&nbsp;
                        <span>{{detailsitem.destinationmobileno}}</span>
                    </div>
                     
                    <div class="col-md-3">
                        <span><b>Destination Poc Name :</b></span>&nbsp;
                        <span>{{detailsitem.destinationspocpersonname}}</span>
                    </div>
                     
                </b-row>
                <br>
                <b-row class="col-md-12" >
               
                    <div class="col-md-3">
                        <span><b> Destination Address :</b></span>&nbsp;
                        <span>{{detailsitem.destinationaddress}} </span>
                    </div>
                      
                    <div class="col-md-3">
                        <span><b>Destination City :</b></span>&nbsp;
                        <span>{{detailsitem.destinationcity}}</span>
                        
                    </div>
                    <div class="col-md-3">
                        <span><b>Destination State :</b></span>&nbsp;
                        <span>{{detailsitem.destinationstate}}</span>
                    </div> 
                      
                    <div class="col-md-3">
                        <span><b>Destination Pincode :</b></span>&nbsp;
                        <span>{{detailsitem.destinationpincode}}</span>
                        
                    </div>
                    <div class="col-md-12 pull-right"> 
                        <div slot="footer" class="text-right">
                            <b-button  size="sm" variant="danger" @click="detailsCancel()">Close</b-button>
                        </div>
                    </div>
                     
                </b-row>
            </template>
            <template slot="modal-footer" slot-scope="{ cancel }">
              <b-button size="sm" variant="danger" @click="detailsCancel()" style="display:none">
                Cancel
              </b-button>
            </template>
        </b-modal>

        <!-- Modal For MPS Count details -->
        <b-modal size="lg" title="MPS Count Details" v-model="productdetailsModal" @ok="productdetailsModal = false" hide-footer>
            <template slot="default" slot-scope="{ hide }">
            <b-row>
                <b-col sm="12" class="text-right">
                    <p> <b>Total Records :<span style="color:red;"> {{mpstotalRows}}</span></b> </p>
                </b-col>   
                <div style="float: left;">
                    <span class="badge ml-2" 
                    style="background-color:rgb(192, 57, 43); color: white;font-size: 13px; padding: 3px;">DB</span> Damage Box&nbsp;&nbsp;
                    <span class="badge ml-2" 
                        style="background-color:rgb(23, 130, 109); color: white;font-size: 11px; padding: 3px;">SB</span> Shortage Box&nbsp;&nbsp;
                </div>
                <b-col sm="12"> 
                    <b-table show-empty stacked="md"  :items="mpsitems"  :fields="mpsfields"  :current-page="mpscurrentPage"  :per-page="mpsperPage"     :sort-by.sync="sortBy"  :sort-desc.sync="sortDesc"   :sort-direction="sortDirection"    @filtered="onFiltered"    :outlined="outlined" :busy="isBusymps" >
                        <div slot="table-busy" class="text-center text-danger my-2">
                            <b-spinner class="align-middle"></b-spinner>
                            <strong>Loading...</strong>
                        </div> 
                        <template slot="shippingid" slot-scope="row">
                            <span>{{row.item.shippingid}}</span>
                            <br>
                            <span v-if="row.item.is_defective=='YES'" class="badge " style="background-color:#c0392b;color:white;font-size: 9px;padding: 3px;cursor: pointer;"  v-b-modal.defective_image_modal @click="Viewimagedetails(row.item)">DB</span>
                            &nbsp;
                            <span v-if="row.item.is_shortage=='Yes'" class="badge " style="background-color:rgb(23, 130, 109);color:white;font-size: 9px;padding: 3px;cursor: pointer;">SB</span>
                        </template>
                        <template slot="mpsvalue" slot-scope="row">
                            <span>&#8377; {{row.item.mpsvalue}} </span>
                        </template> 
                        <template slot="physicalweight" slot-scope="row">
                            <span> {{row.item.physicalweight}} {{row.item.physicalweightunit}}</span>
                        </template>
                        <template slot="physicalweight" slot-scope="row">
                            <span> {{row.item.physicalweight}} {{row.item.physicalweightunit}}</span>
                        </template>
                        <template slot="breadth" slot-scope="row">
                            <span> {{row.item.breadth}} {{row.item.lbhunit}}</span>
                        </template>
                        <template slot="length" slot-scope="row">
                            <span> {{row.item.length}} {{row.item.lbhunit}}</span>
                        </template>
                        <template slot="height" slot-scope="row">
                            <span> {{row.item.height}} {{row.item.lbhunit}}</span>
                        </template>
                    </b-table> 
                </b-col>
            </b-row> 
            <b-row>
                <b-col md="6" class="my-1" v-if="mpstotalRows>10">
                <b-pagination
                    v-model="mpscurrentPage"
                    :total-rows="mpstotalRows"
                    :per-page="mpsperPage"
                    class="my-0"
                    ></b-pagination>
                </b-col> 
            </b-row>
            <div class="col-md-12 pull-right"> 
                <div slot="footer" class="text-right">
                
                <b-button  size="sm" variant="danger" @click="modalCancel()">Close</b-button>
                </div>
            </div>
        </template>
        <template slot="modal-footer" slot-scope="{ cancel }">
            <b-button size="sm" variant="danger" @click="modalCancel()" style="display:none">
            Cancel
            </b-button>
        </template>
        </b-modal>
    </div>
</template>
<script>
import CONSTANTS from '@/utils/constants'
import Utils from '@/utils'
import auth from '@/utils/auth'
export default {
    data: function(){
        return{
            deliveryStatus: null,
            dateKey: '',
            dateLabel: 'NA',
            fields: [],
            fields1 : [
                // { key: 'select', label: 'Select', sortable: false, sortDirection: 'desc' },
                { key: 'parentawb', label: 'Parent AWB', sortable: true, sortDirection: 'desc' },
                { key: 'hub_title', label: 'Hub Name', sortable: true, sortDirection: 'desc' },
                { key: 'zone_title', label: 'Zone Name', sortable: true, sortDirection: 'desc' },
                { key: 'invoiceno', label: 'Load ID', sortable: true, sortDirection: 'desc' },
                { key: 'warehouseid', label:'WareHouse ID', sortable: true, sortDirection: 'desc' },
                { key: 'invoicevalue', label: 'Invoice Value', sortable: true, sortDirection: 'desc' },
                { key: 'awbphysicalweight', label: 'Weight', sortable: true, sortDirection: 'desc' },
                { key: 'mpscount', label: 'MPS Count', sortable: true, sortDirection: 'desc' },
                { key: 'delivery_mode', label: 'Delivery Mode', sortable: true, sortDirection: 'desc' },
                { key: 'shipmentstatus', label: 'Shipment Status', sortable: true, sortDirection: 'desc' },
                { key: 'deliverystatus', label: 'Delivery Status', sortable: true, sortDirection: 'desc' },
                { key: 'warehousename', label: 'WareHouse Name', sortable: true, sortDirection: 'desc' },
                { key: 'destinationaddress', label: 'Destination Address', sortable: true, sortDirection: 'desc' },
                { key: 'bookingdonedate', label: 'BookingDone Date', sortable: true, sortDirection: 'desc' },
                { key: 'zoneinscandate', label: 'ZoneIn Date', sortable: true, sortDirection: 'desc' },
            ],
            fields2 : [
                // { key: 'select', label: 'Select', sortable: false, sortDirection: 'desc' },
                { key: 'parentawb', label: 'Parent AWB', sortable: true, sortDirection: 'desc' },
                { key: 'hub_title', label: 'Hub Name', sortable: true, sortDirection: 'desc' },
                { key: 'zone_title', label: 'Zone Name', sortable: true, sortDirection: 'desc' },
                { key: 'invoiceno', label: 'Load ID', sortable: true, sortDirection: 'desc' },
                { key: 'warehouseid', label:'WareHouse ID', sortable: true, sortDirection: 'desc' },
                { key: 'invoicevalue', label: 'Invoice Value', sortable: true, sortDirection: 'desc' },
                { key: 'awbphysicalweight', label: 'Weight', sortable: true, sortDirection: 'desc' },
                { key: 'mpscount', label: 'MPS Count', sortable: true, sortDirection: 'desc' },
                { key: 'delivery_mode', label: 'Delivery Mode', sortable: true, sortDirection: 'desc' },
                { key: 'shipmentstatus', label: 'Shipment Status', sortable: true, sortDirection: 'desc' },
                { key: 'deliverystatus', label: 'Delivery Status', sortable: true, sortDirection: 'desc' },
                { key: 'warehousename', label: 'WareHouse Name', sortable: true, sortDirection: 'desc' },
                { key: 'destinationaddress', label: 'Destination Address', sortable: true, sortDirection: 'desc' },
                { key: 'bookingdonedate', label: 'BookingDone Date', sortable: true, sortDirection: 'desc' },
                { key: 'zoneoutscandate', label: 'ZoneOut Date', sortable: true, sortDirection: 'desc' },
            ],
            fields3 : [
                // { key: 'select', label: 'Select', sortable: false, sortDirection: 'desc' },
                { key: 'parentawb', label: 'Parent AWB', sortable: true, sortDirection: 'desc' },
                // { key: 'hub_title', label: 'Hub Name', sortable: true, sortDirection: 'desc' },
                // { key: 'zone_title', label: 'Zone Name', sortable: true, sortDirection: 'desc' },
                { key: 'vehicle_name', label: 'Vehicle Name', sortable: true, sortDirection: 'desc' },
                { key: 'vehicle_no', label: 'Vehicle Number', sortable: true, sortDirection: 'desc' },
                { key: 'invoiceno', label: 'Load ID', sortable: true, sortDirection: 'desc' },
                { key: 'warehouseid', label:'WareHouse ID', sortable: true, sortDirection: 'desc' },
                { key: 'invoicevalue', label: 'Invoice Value', sortable: true, sortDirection: 'desc' },
                { key: 'awbphysicalweight', label: 'Weight', sortable: true, sortDirection: 'desc' },
                { key: 'mpscount', label: 'MPS Count', sortable: true, sortDirection: 'desc' },
                { key: 'delivery_mode', label: 'Delivery Mode', sortable: true, sortDirection: 'desc' },
                { key: 'shipmentstatus', label: 'Shipment Status', sortable: true, sortDirection: 'desc' },
                { key: 'deliverystatus', label: 'Delivery Status', sortable: true, sortDirection: 'desc' },
                { key: 'warehousename', label: 'WareHouse Name', sortable: true, sortDirection: 'desc' },
                { key: 'destinationaddress', label: 'Destination Address', sortable: true, sortDirection: 'desc' },
                { key: 'bookingdonedate', label: 'BookingDone Date', sortable: true, sortDirection: 'desc' },
                { key: 'dispatchoutscandate', label: 'Dispatch Date', sortable: true, sortDirection: 'desc' },
            ],
            currentPage:1,
            perPage:60,
            isBusy: false,
            items:[],
            noofpages:0,
            totalRows:0,
            userData:null,
            userInfo:null,
            searchvaluesarr:[],
            options: [
                { value: "", text: 'Please select an option' },
                { value: 'Hub_To_Hub', text: 'Hub_To_Hub' },
                { value: 'Direct', text: 'Direct' },
            ],
            loadurl:'',
            deliveryMode: '',
            searchVal: '',

            // awb details modal
            detailsitem: {},
            awbdetailsmodal:false,

            // mps count modal
            mpscurrentPage:1,
            productdetailsModal: false,
            isBusymps: false,
            mpsitems: [],
            mpstotalRows: 0,
            mpscurrentPage: 1,
            mpsperPage: 10,
            mpsfields:[
                { key: 'shippingid', label: 'MPS No', sortable: true, sortDirection: 'desc' },
                { key: 'mpsvalue', label: 'MPS Value', sortable: true, sortDirection: 'desc' },
                { key: 'length', label: 'Length', sortable: true, sortDirection: 'desc' },
                { key: 'breadth', label: 'Breadth', sortable: true, sortDirection: 'desc' },
                
                { key: 'height', label: 'Height', sortable: true, sortDirection: 'desc' },
                { key: 'physicalweight', label: 'Physical Weight', sortable: true, sortDirection: 'desc' },
                { key: 'deliverystatus', label: 'Delivery Status', sortable: true, sortDirection: 'desc' },
            ],
        }
    },
    props:["route_id","type"],
    created: function() {
        this.userData = localStorage.getItem('userData');
        this.userInfo = JSON.parse(this.userData);
        
        console.log('this.params.type----------->',this.type)
        if(this.type=='ZoneInScan') {
            this.fields = this.fields1
            this.deliveryStatus = 'ZoneInScan'
        }
        if(this.type=='ZoneOutScan') {
            this.fields = this.fields2
            this.deliveryStatus = 'ZoneOutScan'
        }
        if(this.type=='DispatchOutScan') {
            this.fields = this.fields3
            this.deliveryStatus = 'DispatchOutScan'

        }
        this.getAssignedShipment(1)
    },
    mounted() {
    },
    methods: {
        clickCallback(page_no){
            this.getAssignedShipment(page_no);
        },
        getAssignedShipment:function(pageNo){
            this.isBusy = true;
           
            // let pincode=JSON.stringify(this.userInfo.pickuplocationpincode);

            let obj = {
                for_status: this.deliveryStatus,
                sysusermasterid:`${this.userInfo.sysusermasterid}`,
                usertype:`${this.userInfo.user_type}`,
                payloadArr:this.searchvaluesarr,
                page_no:`${pageNo}`,
                is_asn: this.route_id == 'normal' ? 'NO': 'YES',
            } 
            this.$http
            .post(`${CONSTANTS.MISREPORT_API_URL}/getAllocatedLoadsListing`,obj)
            .then(result => {
                console.log(result.body);
                this.isBusy = !this.isBusy;
                if(result.body.returnmsg == "successful"){
                    this.items  = result.body.returnvalue;
                    this.totalRows = result.body.totalcount;  
                    let tempNoOfPages = parseInt(result.body.totalcount)/60;
                    this.noofpages=Math.ceil(tempNoOfPages);
                    console.log('sucesssssssssssssssssss---------------------->')
                }else {
                    this.items  = [];
                    this.totalRows = 0;
                }
            }).catch(err => {
                console.log('error', err)
            })
        },
        clearSearch(){
            this.searchVal='';
            this.searchvaluesarr=[];
            this.deliveryMode='';
            this.getAssignedShipment(this.pageNum)
        },
        searchInLoadManagement(){
            console.log('this.searchVal------------>',this.searchVal)
            console.log('this.deliveryMode--------->',this.deliveryMode)
            let tempSearchArr =  this.searchVal ?  this.searchVal.split(/[','|' '|'\n']/) : []
            let tempDeliveryModeArr = this.deliveryMode ? this.deliveryMode.split(',') : []
            this.searchvaluesarr = [...tempSearchArr,...tempDeliveryModeArr]
            this.getAssignedShipment(1)
        },
        viewDetails: function(value){
            this.awbdetailsmodal=true;
            this.detailsitem=value;
        },
        detailsCancel: function(){
            this.awbdetailsmodal=false;
        },
        viewProduct:function(value){
            this.mpscurrentPage=1;
            this.productdetailsModal=true;
            this.isBusymps = true;
            
            let obj = {
                parentawb: value.parentawb,
            }

            this.$http
            .post(`${CONSTANTS.MISREPORT_API_URL}/getMPSListFromLoad`,obj)
            .then(result => {
                console.log(result.body);
                this.isBusymps = false;
                if(result.body.returnmsg === "successful"){
                    this.mpsitems  = result.body.returnvalue;
                    this.mpstotalRows = result.body.returnvalue.length
                }else {
                    this.mpsitems  = [];
                    this.mpstotalRows = 0
                }
            }).catch(err => {
                console.log('error', err)
            })
        },
        modalCancel:function(){
          this.productdetailsModal=false;
        },
    }
}
</script>
<style>

</style>